import { memo, useCallback, useState } from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { RefreshIcon } from 'foundations-assets';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Small } from 'foundations-components/transitional/components/Small';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { CAMPAIGN_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useFetchHasCampaigns } from 'universal-associations-select/hooks/useFetchHasCampaigns';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CampaignsEmptyState = ({
  refetchOptions,
  engagementOrInteractionType,
  apiClient
}) => {
  const {
    data,
    loading
  } = useFetchHasCampaigns(apiClient);
  const [hasClickedCreateCampaign, setHasClickedCreateCampaign] = useState(false);
  const handleClickCreateCampaign = useCallback(() => {
    setHasClickedCreateCampaign(true);
    CrmLogger.log('universalAssociationsSelect', {
      action: 'create campaign',
      toObjectTypeId: CAMPAIGN_TYPE_ID,
      engagementOrInteractionType,
      location: 'campaigns association empty state',
      pluralObjectName: 'Campaigns',
      subjectObjectTypeId: CAMPAIGN_TYPE_ID
    });
  }, [engagementOrInteractionType]);
  if (loading || !data) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlockStart: "400"
    });
  }
  if (data.hasCampaigns) {
    return /*#__PURE__*/_jsxs(ResultsMessage, {
      marginBlock: "0",
      illustration: "empty-state-charts",
      illustrationProps: {
        width: 130,
        marginBlockStart: '0',
        marginBlockEnd: '200'
      },
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: 'universalAssociationsSelect.searchResults.noResults.noRecordsFound'
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalAssociationsSelect.searchResults.noResults.searchToFind"
      })]
    });
  }
  return /*#__PURE__*/_jsx(ResultsMessage, {
    marginBlock: "0",
    illustration: "campaigns",
    illustrationProps: {
      width: hasClickedCreateCampaign ? 60 : 80,
      marginBlockStart: '0',
      marginBlockEnd: '200'
    },
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      align: "center",
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "universalAssociationsSelect.searchResults.campaigns.title_jsx",
          options: {
            className: 'p-all-0',
            style: {
              marginTop: '-2px',
              fontSize: '12px'
            },
            href: 'https://knowledge.hubspot.com/campaigns/understand-campaigns',
            use: 'link',
            external: true
          },
          elements: {
            Button
          }
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "primary",
        size: "small",
        onClick: handleClickCreateCampaign,
        href: `/marketing/${PortalIdParser.get()}/campaigns`,
        external: true,
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "universalAssociationsSelect.searchResults.campaigns.createButton"
        })
      }), hasClickedCreateCampaign && /*#__PURE__*/_jsxs(Button, {
        use: "link",
        size: "small",
        onClick: refetchOptions,
        marginBlockStart: "200",
        children: [/*#__PURE__*/_jsx(RefreshIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "universalAssociationsSelect.searchResults.campaigns.refreshButton"
        })]
      })]
    })
  });
};
export default /*#__PURE__*/memo(CampaignsEmptyState);